export default __webpack_public_path__ + "static/media/watchcloud-video.8e25b66c.mp4";